// extracted by mini-css-extract-plugin
export var messageSideLeft = "_pv-1";
export var messageSideRight = "_pv-2";
export var orderLookupBubbleContainer = "_pv-0";
export var submitButton = "_pv-3";